import type { UIEvent } from 'react';

import type { AddressProps, SummaryItemProps, PaymentProps, ValuesProps } from './components';

export enum SUMMARY_CONST {
  TEST_ID = 'summary-view',
}
export type ModalPaymentMethodProps = {
  isOpen: boolean;
  onClose: (event: UIEvent<HTMLButtonElement>) => void;
  contentType: string;
};

export type SummaryProps = AddressProps & SummaryItemProps & ValuesProps & PaymentProps;
